import React, { useState, useContext, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { CartContext } from '../../contexts/CartContext';
import { TmShipLevel } from '../../tscapi/model/order';

import { OrderProduct } from './order-product.component';
import { Product } from './product.component';

export const ItemSummary = () => {
    const { t } = useTranslation();
    const { cartData, orderHistoryDetail, orderModificationMode, reviewModifiedCart, setServerErrorMessage } =
        useContext(CartContext);

    const [existingItemList, setExistingItemList] = useState<TmShipLevel[] | null>(null);
    const [collapseToggle, setCollapseToggle] = useState(false);
    const [collapseExistingItemsToggle, setCollapseExistingItemsToggle] = useState(false);
    const [itemCount, setItemCount] = useState(0);

    useEffect(() => {
        if (cartData != null && cartData.CartLines != null && cartData.CartLines.length > 0) {
            setItemCount(cartData.OrderSummary.TotalQuantity);
        }
    }, [cartData]);

    useEffect(() => {
        if (orderModificationMode) {
            const updateCartItems = async () => {
                try {
                    await reviewModifiedCart(cartData);
                } catch (error) {
                    setServerErrorMessage(error instanceof Error ? error.message : String(error));
                }
            };
            updateCartItems();
        }
    }, [cartData, orderModificationMode, reviewModifiedCart, setServerErrorMessage]);

    useEffect(() => {
        if (orderHistoryDetail) {
            setExistingItemList(orderHistoryDetail.ShipLevels);
        }
    }, [orderHistoryDetail]);

    const handleToggle = (e) => {
        e.preventDefault();
        setCollapseToggle(!collapseToggle);
    };
    const handleExistingItemsToggle = (e) => {
        e.preventDefault();
        setCollapseExistingItemsToggle(!collapseExistingItemsToggle);
    };
    const setToggleClass = () => {
        return collapseToggle ? 'collapse__button grey collapse' : 'collapse__button grey';
    };

    const setExistingItemsToggleClass = () => {
        return collapseExistingItemsToggle ? 'collapse__button grey collapse' : 'collapse__button grey';
    };

    useEffect(() => {
        if (window.innerWidth < 768) {
            //originally we had mobile keep the items list closed, but have been now asked to keep it open
            setCollapseToggle(true);
            setCollapseExistingItemsToggle(false);
        } else {
            setCollapseToggle(true);
            setCollapseExistingItemsToggle(false);
        }
    }, []);

    return (
        <>
            {itemCount > 0 && (
                <>
                    <button className={setToggleClass()} data-collapse="collapse__productlist" onClick={handleToggle}>
                        {orderModificationMode ? (
                            <>{t('Items Being Added', { order: itemCount })}</>
                        ) : (
                            <> {t('Items in Order', { order: itemCount })}</>
                        )}
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" className="collapse__arrow">
                            <path d="M7.41 7.84L12 12.42l4.59-4.58L18 9.25l-6 6-6-6z" />
                        </svg>
                    </button>
                    {cartData && cartData.CartLines && cartData.CartLines.length > 0 && cartData.ShipCode ? (
                        <div id="collapse__productlist" className={collapseToggle ? '' : 'hidden'}>
                            {cartData.CartLines.map((lines, index) => (
                                <Product
                                    CartLine={lines}
                                    CartProducts={cartData.Products}
                                    CartMessages={cartData.CartMessages}
                                    HasRemoteShipTo={cartData.HasRemoteShipTo}
                                    IsPickup={
                                        cartData.ShipCode == '35' ||
                                        cartData.ShipCode == '07' ||
                                        cartData.ShipCode == '41'
                                    }
                                    Promocode={cartData.PromoCode}
                                    key={index}
                                ></Product>
                            ))}
                        </div>
                    ) : null}
                </>
            )}
            {orderModificationMode && existingItemList && existingItemList.length > 0 && (
                <>
                    <button
                        className={setExistingItemsToggleClass()}
                        data-collapse="collapse__productlist"
                        onClick={handleExistingItemsToggle}
                    >
                        {t('Existing Items', { orderedItems: existingItemList[0].Items.length })}
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" className="collapse__arrow">
                            <path d="M7.41 7.84L12 12.42l4.59-4.58L18 9.25l-6 6-6-6z" />
                        </svg>
                    </button>
                    {existingItemList[0].Items && existingItemList[0].Items.length > 0 ? (
                        <div id="collapse__productlist" className={collapseExistingItemsToggle ? '' : 'hidden'}>
                            {existingItemList[0].Items.map((lines, index) => (
                                <OrderProduct ShipmentItem={lines} key={index}></OrderProduct>
                            ))}
                        </div>
                    ) : null}
                </>
            )}
        </>
    );
};
